/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ETypeOfDurationDashboard = 'ThisYear' | 'LastYear' | 'AllTime';

export const ETypeOfDurationDashboard = {
    ThisYear: 'ThisYear' as ETypeOfDurationDashboard,
    LastYear: 'LastYear' as ETypeOfDurationDashboard,
    AllTime: 'AllTime' as ETypeOfDurationDashboard
};

